"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionDRPicasoWithResetInitializer = exports.SessionCCWithResetInitializer = exports.USDSessionWithResetInitializer = exports.SessionUSDInitializer = exports.SessionDRPicasoInitializer = exports.SessionCCDevInitializer = exports.AsisSessionResetInitializer = exports.AsisSessionInitializer = exports.SessionWithResetHybridInitializer = exports.SessionHybridV2Initializer = exports.SessionHybridInitializer = exports.SessionWithResetInitializer = exports.SessionInitializer = exports.SessionInitializationError = void 0;
/* eslint-disable complexity */
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const _1 = require(".");
const storage_1 = require("./web/storage");
const storage_2 = require("./asis/storage");
const storage_3 = require("./cc/storage");
const store_1 = require("../../store");
const SESSION_ERROR = 'Session initialization error';
class SessionInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(SESSION_ERROR, message);
    }
}
exports.SessionInitializationError = SessionInitializationError;
class SessionInitializer extends web_ui_framework_1.Initializer {
    constructor(config, eventBus) {
        super([eventBus]);
        this.launch = () => {
            try {
                const { bankId, getLoginDomain, language } = this.config;
                const sessionStoreConfig = this.config.getSessionStoreConfig?.();
                const defaultStore = (0, store_1.getDefaultCookiesStore)({ credentialsDomain: getLoginDomain() });
                let session;
                if (sessionStoreConfig) {
                    const { store, originStore, removeOrigin } = sessionStoreConfig;
                    session = new _1.MbSession(new storage_1.MbSessionStorage(store));
                    if (originStore) {
                        const originSession = new _1.MbSession(new storage_1.MbSessionStorage(originStore));
                        const originSessionData = originSession.getData();
                        //TODO Este finishSession no debería de ser un finish como tal, si no un borra los datos de sesión.
                        removeOrigin && originSession.finishSession();
                        originSessionData && session.updateData(originSessionData);
                    }
                }
                else {
                    session = new _1.MbSession(new storage_1.MbSessionStorage(defaultStore));
                }
                session.setXHR(new web_ui_framework_1.XHR([new web_ui_framework_1.XHRAcceptLanguagePlugin(language), new web_ui_security_1.XHRAuthPlugin(session), new web_ui_framework_1.XHRBankIdPlugin(bankId)]));
                return session;
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.config = config;
    }
}
exports.SessionInitializer = SessionInitializer;
class SessionWithResetInitializer extends web_ui_framework_1.Initializer {
    constructor(config, sessionData, eventBus) {
        super([eventBus]);
        this.launch = () => {
            try {
                const sessionInit = new SessionInitializer(this.config, this.eventBus);
                const session = sessionInit.launch();
                session.finishSession();
                session.initSession(this.sessionData);
                return session;
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.config = config;
        this.sessionData = sessionData;
        this.eventBus = eventBus;
    }
}
exports.SessionWithResetInitializer = SessionWithResetInitializer;
class SessionHybridInitializer extends web_ui_framework_1.Initializer {
    constructor(mobileConnector, eventBus) {
        super([mobileConnector, eventBus]);
        this.launch = () => {
            try {
                return new _1.MbHybridSession(new web_ui_security_1.SessionStorage((0, store_1.getDefaultMemoryStore)()), this.mobileConnector.getInitialized().refreshToken);
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.mobileConnector = mobileConnector;
    }
}
exports.SessionHybridInitializer = SessionHybridInitializer;
class SessionHybridV2Initializer extends web_ui_framework_1.Initializer {
    constructor(mobileConnector, eventBus) {
        super([mobileConnector, eventBus]);
        this.launch = () => {
            try {
                return new _1.MbHybridSessionV2(new web_ui_security_1.SessionStorage((0, store_1.getDefaultMemoryStore)()), this.mobileConnector.getInitialized().refreshTokenV2);
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.mobileConnector = mobileConnector;
    }
}
exports.SessionHybridV2Initializer = SessionHybridV2Initializer;
class SessionWithResetHybridInitializer extends web_ui_framework_1.Initializer {
    constructor(sessionData, eventBus, mobileConnector) {
        super([eventBus, mobileConnector]);
        this.launch = () => {
            try {
                const sessionInit = new SessionHybridInitializer(this.mobileConnector, this.eventBus);
                const session = sessionInit.launch();
                session.finishSession();
                session.initSession(this.sessionData);
                return session;
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.sessionData = sessionData;
        this.eventBus = eventBus;
        this.mobileConnector = mobileConnector;
    }
}
exports.SessionWithResetHybridInitializer = SessionWithResetHybridInitializer;
class AsisSessionInitializer extends web_ui_framework_1.Initializer {
    constructor(config, eventBus) {
        super();
        this.launch = () => {
            try {
                const { domain } = this.config;
                return new _1.MbAsisSession(new storage_2.MbAsisSessionStorage((0, store_1.getDefaultCookiesStore)({ credentialsDomain: domain })));
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.config = config;
        this.eventBus = eventBus;
    }
}
exports.AsisSessionInitializer = AsisSessionInitializer;
class AsisSessionResetInitializer extends web_ui_framework_1.Initializer {
    constructor(config, sessionData, eventBus) {
        super();
        this.launch = () => {
            try {
                const sessionInit = new AsisSessionInitializer(this.config, this.eventBus);
                const session = sessionInit.launch();
                session.finishSession();
                session.initSession(this.sessionData);
                return session;
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.config = config;
        this.sessionData = sessionData;
        this.eventBus = eventBus;
    }
}
exports.AsisSessionResetInitializer = AsisSessionResetInitializer;
class SessionCCDevInitializer extends web_ui_framework_1.Initializer {
    constructor(config, eventBus) {
        super();
        this.launch = () => {
            try {
                const { bankId, language } = this.config;
                const session = new _1.MbCCDevSession(new storage_3.MbCCSessionStorage((0, store_1.getDefaultCookiesStore)()));
                const plugins = [new web_ui_framework_1.XHRAcceptLanguagePlugin(language), new web_ui_framework_1.XHRBankIdPlugin(bankId)];
                session.setXHR(new web_ui_framework_1.XHR({
                    plugins,
                }));
                return session;
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.config = config;
        this.eventBus = eventBus;
    }
}
exports.SessionCCDevInitializer = SessionCCDevInitializer;
class SessionDRPicasoInitializer extends web_ui_framework_1.Initializer {
    constructor(config, eventBus, sessionData) {
        super();
        this.launch = () => {
            try {
                const { bankId, language } = this.config;
                const session = new _1.MbDRPicasoSession(new storage_3.MbCCSessionStorage((0, store_1.getDefaultCookiesStore)()));
                const plugins = [new web_ui_framework_1.XHRAcceptLanguagePlugin(language), new web_ui_framework_1.XHRBankIdPlugin(bankId)];
                session.setXHR(new web_ui_framework_1.XHR({
                    plugins,
                }));
                if (this.sessionData) {
                    session.initSession(this.sessionData);
                }
                return session;
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.config = config;
        this.eventBus = eventBus;
        this.sessionData = sessionData;
    }
}
exports.SessionDRPicasoInitializer = SessionDRPicasoInitializer;
class SessionUSDInitializer extends web_ui_framework_1.Initializer {
    constructor(config, eventBus) {
        super();
        this.launch = () => {
            try {
                const { bankId, language } = this.config;
                const session = new _1.MbUSDSession(new storage_3.MbCCSessionStorage((0, store_1.getDefaultCookiesStore)()));
                const plugins = [new web_ui_framework_1.XHRAcceptLanguagePlugin(language), new web_ui_framework_1.XHRBankIdPlugin(bankId)];
                session.setXHR(new web_ui_framework_1.XHR({
                    plugins,
                }));
                return session;
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.config = config;
        this.eventBus = eventBus;
    }
}
exports.SessionUSDInitializer = SessionUSDInitializer;
class USDSessionWithResetInitializer extends web_ui_framework_1.Initializer {
    constructor(config, sessionData, eventBus) {
        super();
        this.launch = () => {
            try {
                const sessionInit = new SessionUSDInitializer(this.config, this.eventBus);
                const session = sessionInit.launch();
                session.finishSession();
                session.initSession(this.sessionData);
                return session;
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.config = config;
        this.sessionData = sessionData;
        this.eventBus = eventBus;
    }
}
exports.USDSessionWithResetInitializer = USDSessionWithResetInitializer;
class SessionCCWithResetInitializer extends web_ui_framework_1.Initializer {
    constructor(config, sessionData, eventBus) {
        super();
        this.launch = () => {
            try {
                const sessionInit = new SessionCCDevInitializer(this.config, this.eventBus);
                const session = sessionInit.launch();
                session.finishSession();
                session.initSession(this.sessionData);
                return session;
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.config = config;
        this.sessionData = sessionData;
        this.eventBus = eventBus;
    }
}
exports.SessionCCWithResetInitializer = SessionCCWithResetInitializer;
class SessionDRPicasoWithResetInitializer extends web_ui_framework_1.Initializer {
    constructor(config, sessionData, eventBus) {
        super();
        this.launch = () => {
            try {
                const sessionInit = new SessionDRPicasoInitializer(this.config, this.eventBus);
                const session = sessionInit.launch();
                session.finishSession();
                session.initSession(this.sessionData);
                return session;
            }
            catch (e) {
                throw new SessionInitializationError(e);
            }
        };
        this.config = config;
        this.sessionData = sessionData;
        this.eventBus = eventBus;
    }
}
exports.SessionDRPicasoWithResetInitializer = SessionDRPicasoWithResetInitializer;
//# sourceMappingURL=session.initializer.js.map